import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

// Services
import { ContainerService } from '../../services/container.service';
import { SidebarService } from '../../services/sidebar.service';
import {ModalPopupComponent} from '../../modal-popup/modal-popup.component';
import {SettingsService} from '../../services/settings.service';
import {AppBase} from '../../app-base';
import {MessagesService} from '../../services/messages.service';

@Component({
  selector: 'app-layout-dashboard',
  templateUrl: './layout-dashboard.component.html',
  styleUrls: ['./layout-dashboard.component.sass']
})
export class LayoutDashboardComponent extends AppBase implements OnInit {
  @ViewChild(ModalPopupComponent) modalPopup: ModalPopupComponent;

  // variables
  public urlActive = null;
  public subscriptionRoute: Subscription;
  public subscriptionContainer: Subscription;
  public containerLg = false;
  public containerMd = false;
  public activateOverlay = 'none';
  public modalRef: BsModalRef;
  public community = null;
  public communityId: number;
  public userInSession = null;

  constructor(
    private _messagesService: MessagesService,
    private _settingsService: SettingsService,
    private _containerService: ContainerService,
    private modalService: BsModalService,
    private _sidebarService: SidebarService
  ) {
    super();
  }

  ngOnInit() {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.userInSession = JSON.parse(currentUser).name;
    }
    this.community = {
      name: localStorage.getItem('currentCommunity'),
    };

    // oyente
    this.subscriptionRoute = this._sidebarService.observableRoute$
      .subscribe(
        res => {
          this.urlActive = this.removeQueryStrings(res);
        });

    this.managePopups();
  }

  private removeQueryStrings(url: string): string {
    const splitUrl = url.split('?');
    return splitUrl[0];
  }

  // cerramos container
  public closeContainer(): void {
    this.activateOverlay = 'none';
    this.containerLg = false;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  public managePopups() {
    this._messagesService.getPopupActive()
      .subscribe(response => {
        response.forEach(popup => {
          switch (popup.name) {
            case 'PAYMENT_ACTIVATION':
              // if (this.khipuPopup(popup)) {
              //   return;
              // }
              this.triggerPopup(popup);
          }
        });
      }, error => {
        console.log(error);
      });
  }

  public khipuPopup(popup: any) {
    if (this.getCookie(`popup_${popup.id}`)) {
      return false;
    }
    this._settingsService.getSettings(this.getStorageItem('propertySesion').communityId)
      .subscribe((response) => {
        const khipuSettings = [ 'KHIPU_RECIVER_ID', 'KHIPU_SECRET', 'KHIPU_ENABLED_PAYMENT_METHODS', 'KHIPU_BANK_ACCOUNT_ID', 'WEBPAY_CODE', 'MERCADOPAGO_SETTINGS' ];
        const khipuCommunitySettings = response.filter(x => khipuSettings.indexOf(x.communitySettingsField.key) !== -1);
          if (khipuCommunitySettings.length < 1) {
          return false;
        }
        this.triggerPopup(popup);
        return true;
      }, error => {
        console.log(error);
      });

  }

  public triggerPopup(popup) {
    setTimeout(() => {
      this.modalPopup.openModal({
        popupID: popup.id,
        doNotDisturb: +popup.not_disturb || 0,
        dismissText: popup.dismiss_text || '',
        ctaText: popup.cta_text || '',
        ctaLink: popup.cta_link || '',
        ctaTarget: popup.cta_target || '',
        moreInfoText: popup.more_text || '',
        moreInfoLink: popup.more_link || '',
        moreInfoTarget: popup.more_target || '',
        imageContent: popup.image_content || '',
        customStyles: popup.custom_styles || '',
      });
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/layout-dashboard/layout-dashboard.component.ts